export const ChatStatus = {
  Start: 'start',
  Working: 'working',
  Thinking: 'thinking',
  Searching: 'searching',
  Streaming: 'streaming',
  Answer: 'answer',
  Stopped: 'stopped',
  ErrorAnswer: 'error-answer',
  NoAnswer: 'no-answer',
} as const;

export type ChatStatus = (typeof ChatStatus)[keyof typeof ChatStatus];

export const ToolCallStatus = {
  Calling: 'calling',
  Called: 'called',
} as const;

export type ToolCallStatus =
  (typeof ToolCallStatus)[keyof typeof ToolCallStatus];

export interface ToolCallLine {
  id: string;
  name: string;
  status: ToolCallStatus;
  parentMessageId?: string;
}

export interface Suggestion {
  id: string;
  text: string;
}

export const ChatView = {
  Chat: 'chat',
  History: 'history',
} as const;

export type ChatView = (typeof ChatView)[keyof typeof ChatView];

export interface Session {
  id: string;
  title: string;
  createdAt: string;
  updatedAt: string;
}
